import { CardPaymentsTableColumnsIntl } from 'types/i18n';

export const cardPaymentsTableColumnsIntl: CardPaymentsTableColumnsIntl = {
  id: 'id',
  organization: 'Организация',
  fullName: 'ФИО',
  recievedAmount: 'Поступило',
  creditedAmount: 'На баланс',
  status: 'Статус',
  updatedAt: 'Обновление',
  createdAt: 'Дата создания',
};
